module.exports = __webpack_public_path__ + "img/area-part3-222.3a753d39.png";